import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './Whatsapp.css';

const WhatsAppButton = () => {
  return (
    <div className="wa-wrapper">
      <span className="wa-tooltip">
        আমাদের সাথে WhatsApp-এ কথা বলুন
      </span>

      <a
        href="https://wa.me/8801341707373"
        target="_blank"
        rel="noopener noreferrer"
        className="wa-fab"
      >
        <span className="wa-pulse" />
        <span className="wa-pulse wa-pulse-delay" />
        <FaWhatsapp size={26} />
      </a>
    </div>
  );
};

export default WhatsAppButton;